window.addEventListener('pageshow',function(e){
  if (window.__bpStallTimer) {
    clearTimeout(window.__bpStallTimer);
    window.__bpStallTimer = null;
  }

  if(e.persisted){
    window.checkoutInProgress=false;
    window.__bpExpectedCheckoutNav=false;

    var b=document.getElementById('place-order-btn-bottom');
    if(b){
      b.disabled=false;
      b.style.pointerEvents='auto';
      b.innerHTML='Print My Blueprints<br><span style="font-size:0.75rem;font-weight:400;opacity:0.85;">(Checkout)</span>';
    }

    var bar=document.getElementById('bp-checkout-diag');
    if(bar){
      bar.remove();
    }
  }
});

function bpStep(msg, isError){
  try{
    window.__bpCheckoutStage = msg;
    try { sessionStorage.setItem('bpCheckoutStage', msg); } catch(_) {}
    var bar=document.getElementById('bp-checkout-diag');
    if(!bar){
      bar=document.createElement('div');
      bar.id='bp-checkout-diag';
      bar.style.cssText='position:fixed;top:0;left:0;right:0;z-index:99999;color:#fff;font:20px sans-serif;font-weight:800;padding:16px 12px;text-align:center;';
      document.body.appendChild(bar);
    }
    bar.style.background = isError ? '#b91c1c' : '#1E3A8A';
    bar.textContent = msg;
  }catch(e){}
}

window.addEventListener('pagehide', function(){
  try {
    if (window.__bpStallTimer) {
      clearTimeout(window.__bpStallTimer);
      window.__bpStallTimer = null;
    }

    if (window.checkoutInProgress && !window.__bpExpectedCheckoutNav) {
      sessionStorage.setItem('bpCheckoutInterrupted', Date.now() + '|' + (window.__bpCheckoutStage || 'unknown'));
    }
  } catch(e){}
});

document.addEventListener('DOMContentLoaded', function () {
try {
  const bpLost = sessionStorage.getItem('bpCheckoutInterrupted');
  if (bpLost) {
    sessionStorage.removeItem('bpCheckoutInterrupted');
    const parts = bpLost.split('|');
    if (Date.now() - Number(parts[0]) < 120000) {
      setTimeout(() => bpStep('Checkout was interrupted while: ' + (parts[1] || 'preparing order') + '. Please tap checkout again.', true), 500);
    }
  }
} catch(e){}

function getDynamicDayDate() {
  const now = new Date();
  const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const day = dayNames[now.getDay()];
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const date = String(now.getDate()).padStart(2, '0');
  return `${day} ${month}/${date}`;
}

function getDynamicShipMessage() {
  const now = new Date();
  const localDay = now.getDay();
  const localHour = now.getHours();

  if (localDay === 0 || (localDay === 6 && localHour >= 16)) {
    return `Order now. We will ship your plans Monday morning.`;
  }

  if (localHour < 16) {
    return `Order by 4 PM and your blueprints ship today.`;
  }

  return `Order now - your blueprints will be first in line to print and ship tomorrow morning.`;
}

function getEstimatedDeliveryDate(maxBusinessDays = 2) {
  const now = new Date();

  function holidaysForYear(year) {
    const set = {};
    const mark = (m, d) => { set[m + '-' + d] = true; };

    mark(0, 1);    // New Year's Day
    mark(6, 4);    // Independence Day
    mark(11, 25);  // Christmas Day

    function nthWeekday(month, weekday, n) {
      const first = new Date(year, month, 1);
      let day = 1 + ((7 + weekday - first.getDay()) % 7);
      day += (n - 1) * 7;
      return day;
    }

    function lastWeekday(month, weekday) {
      const last = new Date(year, month + 1, 0);
      const offset = (7 + last.getDay() - weekday) % 7;
      return last.getDate() - offset;
    }

    mark(4, lastWeekday(4, 1));      // Memorial Day
    mark(8, nthWeekday(8, 1, 1));    // Labor Day
    mark(10, nthWeekday(10, 4, 4));  // Thanksgiving

    return set;
  }

  function isBusinessDay(date) {
    const dow = date.getDay();
    if (dow === 0 || dow === 6) return false;

    const holidays = holidaysForYear(date.getFullYear());
    return !holidays[date.getMonth() + '-' + date.getDate()];
  }

  const shipDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  // After 4pm, the order ships on the next available shipping day.
  if (now.getHours() >= 16) {
    shipDate.setDate(shipDate.getDate() + 1);
  }

  // Sunday orders and Saturday-after-4pm orders ship Monday.
  while (shipDate.getDay() === 0) {
    shipDate.setDate(shipDate.getDate() + 1);
  }

  const startDate = new Date(shipDate);
  let added = 0;

  while (added < 1) {
    startDate.setDate(startDate.getDate() + 1);
    if (isBusinessDay(startDate)) added++;
  }

  const endDate = new Date(shipDate);
  added = 0;

  while (added < maxBusinessDays) {
    endDate.setDate(endDate.getDate() + 1);
    if (isBusinessDay(endDate)) added++;
  }

  const months = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  if (
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getFullYear() === endDate.getFullYear()
  ) {
    return months[endDate.getMonth()] + ' ' +
      startDate.getDate() + '-' + endDate.getDate();
  }

  const startStr =
    months[startDate.getMonth()] + ' ' + startDate.getDate();

  const endStr =
    months[endDate.getMonth()] + ' ' + endDate.getDate();

  return startStr + ' - ' + endStr;
}

  let currentStep = 0;
  let pageCount = 0;
  let setCount = 2;
  let selectedSize = null;
  let selectedVariant = null;
  let isColorPrint = false;
  let pageDetectionAttempted = false;
  let waitingForUpload = false;
  let uploadedFiles = [];
  let totalPages = 0;
  let allOrders = []; 
  let pendingRecoveredFiles = [];
  let savedFilesRecoveryFailed = false;
  let recoveredFilesConfirmed = false;
  let recoveringSavedFiles = false;
  let acceptUploadEvents = false;
  
  const UPLOAD_SESSION_KEY = 'blueprintWizardUploadState';
  const UPLOAD_SESSION_TTL = 60 * 60 * 1000;

  function clearUploadSession() {
    try { sessionStorage.removeItem(UPLOAD_SESSION_KEY); } catch (e) {}
  }

  function saveUploadSession() {
    try {
      const files = (uploadedFiles || []).filter(f => f && f.url);
      if (!files.length) {
        clearUploadSession();
        return;
      }

      sessionStorage.setItem(UPLOAD_SESSION_KEY, JSON.stringify({
        savedAt: Date.now(),
        path: window.location.pathname,
        uploadedFiles: files,
        totalPages,
        pageCount,
        currentStep,
        uploadPropsCache: window.uploadPropsCache || {}
      }));
    } catch (e) {}
  }

  function loadUploadSession() {
    try {
      const raw = sessionStorage.getItem(UPLOAD_SESSION_KEY);
      if (!raw) return null;

      const state = JSON.parse(raw);
      const files = (state && state.uploadedFiles) || [];

      if (state.path !== window.location.pathname) {
        clearUploadSession();
        return null;
      }

      if (!state.savedAt || (Date.now() - state.savedAt) > UPLOAD_SESSION_TTL) {
        clearUploadSession();
        return null;
      }

      if (!files.some(f => f && f.url)) {
        clearUploadSession();
        return null;
      }

      return state;
    } catch (e) {
      clearUploadSession();
      return null;
    }
  }

  function saveState() {
    try {
      const state = {
        currentStep,
        pageCount,
        setCount,
        selectedSize,
        selectedVariant,
        isColorPrint,
        pageDetectionAttempted,
        waitingForUpload,
        uploadedFiles,
        totalPages,
        allOrders,
      };
      sessionStorage.setItem('blueprintWizardState', JSON.stringify(state));
      saveUploadSession();
    } catch (e) {
      // sessionStorage unavailable (Safari private mode) - continue without saving
    }
  }

  function loadState() {
    let saved = null;
    try {
      saved = sessionStorage.getItem('blueprintWizardState');
    } catch (e) {
      return false;
    }
    if (saved) {
      try {
        const state = JSON.parse(saved);
        currentStep = state.currentStep || 1;
        pageCount = state.pageCount || 0;
        setCount = state.setCount || 2;
        selectedSize = state.selectedSize || null;
        selectedVariant = state.selectedVariant || null;
        isColorPrint = state.isColorPrint || false;
        pageDetectionAttempted = state.pageDetectionAttempted || false;
        waitingForUpload = state.waitingForUpload || false;
        uploadedFiles = [];
totalPages = 0;
        allOrders = state.allOrders || [];
        
        return true;
      } catch (e) {
        
        return false;
      }
    }
    return false;
  }

window.VARIANT_BY_SIZE_BW = {
  "11x17": "45777099784388",
  "18x24": "44903556022468",
  "22x34": "45615937781956",
  "24x36": "44903556055236",
  "30x42": "44903556088004",
  "36x48": "44903556120772",
  "15x21": "46443483988164",
  "17x22": "46443484119236",
  "18x12": "46443484053700",
  "22x36": "46443483922628",
 "34x44": "45615945482436",
  "26x38": "46447341469892",
  "27x39": "46447341535428",
  "8.5x11": "46447341600964",
  "9x12": "46447341666500"
};

window.VARIANT_BY_SIZE_COLOR = {
  "11x17": "45777099817156",
  "18x24": "45167737241796",
  "22x34": "45615937814724",
  "24x36": "45167737274564",
  "30x42": "45167737307332",
  "36x48": "45167737340100",
  "15x21": "46443484020932",
  "17x22": "46443484152004",
  "18x12": "46443484086468",
  "22x36": "46443483955396",
  "34x44": "45615945515204",
  "26x38": "46447341502660",
  "27x39": "46447341568196",
  "8.5x11": "46447341633732",
  "9x12": "46447341699268"
};

const priceMap = {
  "11x17": 1.95,
  "18x24": 2.20,
  "22x34": 2.75,
  "24x36": 2.85,
  "30x42": 3.45,
  "36x48": 4.85,
  "15x21": 2.20,
  "17x22": 2.20,
  "18x12": 1.95,
  "22x36": 2.85,
  "34x44": 4.45,
  "26x38": 3.25,
  "27x39": 3.45,
  "8.5x11": 0.23,
  "9x12": 0.78
};

const colorPriceMap = {
  "11x17": 2.35,
  "18x24": 2.60,
  "22x34": 3.15,
  "24x36": 3.25,
  "30x42": 3.85,
  "36x48": 5.25,
  "15x21": 2.60,
  "17x22": 2.60,
  "18x12": 2.35,
  "22x36": 3.25,
  "34x44": 4.85,
  "26x38": 3.65,
  "27x39": 3.85,
  "8.5x11": 0.63,
  "9x12": 1.18
};

function getBlueprintDiscount(subtotal) {
  const cents = Math.round((subtotal || 0) * 100);

  if (cents >= 149999) return { percent: 22, code: '22OFF' };
  if (cents >= 100000) return { percent: 20, code: '20OFF' };
  if (cents >= 75001) return { percent: 18, code: '18OFF' };
  if (cents >= 35001) return { percent: 15, code: '15OFF' };
  if (cents >= 25001) return { percent: 12, code: '12OFF' };
  if (cents >= 15000) return { percent: 10, code: '10OFF' };

  return { percent: 0, code: '' };
}

// Full size registry (inches) + which sizes are shown as cards in the grid.
// Used to relabel the first card to a customer's non-standard upload.
const SIZE_REGISTRY = [
  { key: "11x17", w: 11, h: 17, shown: true },
  { key: "18x24", w: 18, h: 24, shown: true },
  { key: "22x34", w: 22, h: 34, shown: true },
  { key: "24x36", w: 24, h: 36, shown: true },
  { key: "30x42", w: 30, h: 42, shown: true },
  { key: "36x48", w: 36, h: 48, shown: true },
  { key: "15x21", w: 15, h: 21, shown: false },
  { key: "17x22", w: 17, h: 22, shown: false },
  { key: "18x12", w: 18, h: 12, shown: false },
  { key: "22x36", w: 22, h: 36, shown: false },
{ key: "34x44", w: 34, h: 44, shown: false },
  { key: "26x38", w: 26, h: 38, shown: false },
  { key: "27x39", w: 27, h: 39, shown: false },
  { key: "8.5x11", w: 8.5, h: 11, shown: false },
  { key: "9x12", w: 9, h: 12, shown: false }
];

  // Decide how a detected page size maps to the grid.
  // Returns { sizeKey, displayLabel, relabel, isCustom, trueLabel }:
  //  - sizeKey     : registry key to route to (drives variant + price)
  //  - displayLabel: what the first card should read
  //  - relabel     : true = rewrite the first card (only when NOT a shown size)
  //  - isCustom    : true = no stocked size matched; rounded up to a containing
  //                  sheet, so the true size is carried to the order for the team
  //  - trueLabel   : the customer's real dimensions, e.g. `22" x 26"`
  function resolveUploadedSize(dominant) {
    const MATCH_TOL = 0.5; // inches; within this of a registry size = that size
    const FIT_PAD   = 0.1; // inches of slack when testing containment

    if (!dominant || !(dominant.width > 0) || !(dominant.height > 0)) return null;

    const fShort = Math.min(dominant.width, dominant.height);
    const fLong  = Math.max(dominant.width, dominant.height);
    const trueLabel = `${Math.round(fShort)}" x ${Math.round(fLong)}"`;

    const labelFor = (key) => key.replace('x', '" x ') + '"';
    const within = (s) => {
      const sShort = Math.min(s.w, s.h), sLong = Math.max(s.w, s.h);
      return Math.abs(fShort - sShort) <= MATCH_TOL && Math.abs(fLong - sLong) <= MATCH_TOL;
    };

    // 1) Matches a SHOWN card -> normal flow, no relabel.
    const shownMatch = SIZE_REGISTRY.find(s => s.shown && within(s));
    if (shownMatch) {
      return { sizeKey: shownMatch.key, displayLabel: labelFor(shownMatch.key), relabel: false, isCustom: false, trueLabel };
    }

    // 2) Matches a stocked EXTRA (not-shown) size -> relabel to that exact size.
    const extraMatch = SIZE_REGISTRY.find(s => !s.shown && within(s));
    if (extraMatch) {
      return { sizeKey: extraMatch.key, displayLabel: labelFor(extraMatch.key), relabel: true, isCustom: false, trueLabel };
    }

    // 3) Nothing we stock matches -> smallest sheet that CONTAINS it (round up).
    let billing = null, billingArea = Infinity;
    SIZE_REGISTRY.forEach(s => {
      const sShort = Math.min(s.w, s.h), sLong = Math.max(s.w, s.h);
      if (fShort <= sShort + FIT_PAD && fLong <= sLong + FIT_PAD) {
        const area = sShort * sLong;
        if (area < billingArea) { billingArea = area; billing = s; }
      }
    });
    if (!billing) {
      // Larger than everything we stock -> fall back to the biggest sheet.
      billing = SIZE_REGISTRY.reduce((a, b) => (a.w * a.h >= b.w * b.h ? a : b));
    }
    return { sizeKey: billing.key, displayLabel: trueLabel, relabel: true, isCustom: true, trueLabel };
  }

  // Most common raw page size (inches) across a set of detected pages.
  function dominantRawSize(pageSizes) {
    if (!pageSizes || !pageSizes.length) return null;
    const counts = {};
    pageSizes.forEach(sz => {
      const key = Math.round(sz.width) + 'x' + Math.round(sz.height);
      counts[key] = counts[key] || { width: sz.width, height: sz.height, n: 0 };
      counts[key].n++;
    });
    let best = null;
    Object.keys(counts).forEach(k => { if (!best || counts[k].n > best.n) best = counts[k]; });
    return best ? { width: best.width, height: best.height } : null;
  }
  const hasRestoredState = loadState();
  const restoredUploadSession = loadUploadSession();

 const cameFromCheckout = hasRestoredState && currentStep >= 7 && allOrders.length > 0;
 const hasRestoredUpload = restoredUploadSession && restoredUploadSession.uploadedFiles && restoredUploadSession.uploadedFiles.length > 0;

 if (cameFromCheckout) {
    clearUploadSession();
    uploadedFiles = [];
    totalPages = 0;
    window.uploadPropsCache = {};
    waitingForUpload = false;
    document.getElementById('step-1')?.classList.add('hidden');
    document.getElementById('steps-container')?.classList.remove('hidden');
    renderReviewSummary();
  } else if (hasRestoredState && hasRestoredUpload && currentStep < 7) {
    uploadedFiles = restoredUploadSession.uploadedFiles || [];
    totalPages = restoredUploadSession.totalPages || uploadedFiles.reduce((sum, file) => sum + (file.pages || 0), 0);
    if (!pageCount && totalPages > 0) pageCount = restoredUploadSession.pageCount || totalPages;
    window.uploadPropsCache = restoredUploadSession.uploadPropsCache || {};
    waitingForUpload = currentStep === 1;

    document.getElementById('step-1')?.classList.add('hidden');
    document.getElementById('steps-container')?.classList.remove('hidden');

    if (currentStep === 1) {
      renderUploadStep();
      showUploadBox();
    } else {
      nextStep(currentStep);
    }
  } else {
    clearUploadSession();
    uploadedFiles = [];
    totalPages = 0;
    window.uploadPropsCache = {};
    waitingForUpload = false;
    pageDetectionAttempted = false;
    allOrders = [];
    selectedSize = null;
    selectedVariant = null;
    pageCount = 0;
    setCount = 2;
    isColorPrint = false;
    try { sessionStorage.removeItem('blueprintWizardState'); } catch (e) {}
    document.getElementById('step-1')?.classList.add('hidden');
    document.getElementById('steps-container')?.classList.remove('hidden');
    currentStep = 1;
    uploadedFiles = [];
    totalPages = 0;
    saveState();
    nextStep(1);
  }

 async function detectPDFPages(directUrl) {
    try {
      let pdfUrl = directUrl || null;
      if (!pdfUrl) {
        document.querySelectorAll('[name^="properties"]').forEach(input => {
          const val = (input.value || '').trim();
          if (val && (val.includes('.pdf') || val.includes('cloudlift.app'))) pdfUrl = val;
        });
      }
      if (!pdfUrl) return null;
      function cloudliftCORS(url){ return url.replace('https://upload.cloudlift.app/s','https://storage.googleapis.com/cloudlift-app-cloud-prod-upload'); }
      const corsEnabledUrl = cloudliftCORS(pdfUrl);
      if (typeof pdfjsLib === 'undefined') return null;
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
      const pdf = await pdfjsLib.getDocument(corsEnabledUrl).promise;
      const numPages = pdf.numPages;
      const pageSizes = [];
      for (let i = 1; i <= numPages; i++) {
        const pg = await pdf.getPage(i);
        const vp = pg.getViewport({scale:1.0});
        pageSizes.push({width:Math.round(vp.width/72), height:Math.round(vp.height/72)});
      }
      return {pageCount: numPages, pageSizes};
    } catch (error) {
      return null;
    }
  }

  function nearestStdSize(ds) {
    const std=[{n:"11x17",w:11,h:17},{n:"18x24",w:18,h:24},{n:"22x34",w:22,h:34},{n:"24x36",w:24,h:36},{n:"30x42",w:30,h:42},{n:"36x48",w:36,h:48}];
    let cl=null,md=Infinity;
    std.forEach(s=>{const d=Math.min(Math.sqrt(Math.pow(ds.width-s.w,2)+Math.pow(ds.height-s.h,2)),Math.sqrt(Math.pow(ds.width-s.h,2)+Math.pow(ds.height-s.w,2)));if(d<md){md=d;cl=s.n}});
    return cl;
  }

  function detectMostCommonSize(pageSizes) {
    const sc={};
    pageSizes.forEach(sz=>{const n=nearestStdSize(sz);sc[n]=(sc[n]||0)+1});
    return Object.keys(sc).reduce((a,b)=>sc[a]>sc[b]?a:b);
  }
  document.querySelectorAll('.size-card').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const size = btn.dataset.size;
    selectedSize = size;
    selectedVariant = window.VARIANT_BY_SIZE_BW[size] || null;
    saveState();
    document.getElementById('step-1')?.classList.add('hidden');
    window.scrollTo({ top: window.pageYOffset - 150, behavior: 'smooth' });
    nextStep(pageCount > 0 ? 5 : 3);
  });
});

if (!window.uploadPropsCache) window.uploadPropsCache = {};

  function readUploadInputsIntoCache() {
    const nodes = document.querySelectorAll('input[name^="properties["],textarea[name^="properties["]');
    nodes.forEach(n => {
      const m = n.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      const key = m[1];
      const val = (n.value || '').trim();
      if (val) uploadPropsCache[key] = val;
    });
  }

  function buildBlueprintUploadPropsFromUploadedFiles(filesArray) {
  const props = {};

  (filesArray || []).forEach((f, idx) => {
    if (!f || !f.url) return;

    const n = idx + 1;

    const filename =
      (f.filename && String(f.filename).trim()) ||
      (f.label && String(f.label).trim()) ||
      `Blueprint File ${n}`;

    props[`Blueprint File ${n}`] = filename;

    props[`_Blueprint File ${n} URL`] = f.url;
  });

  return props;
}

  function buildBlueprintUploadPropsFromCacheFallback() {
    readUploadInputsIntoCache();

    const props = {};
    const keys = Object.keys(uploadPropsCache || {});

    keys.forEach(k => {
      const v = (uploadPropsCache[k] || '').toString().trim();
      if (!v) return;
      if (k.toLowerCase().includes('blueprint upload') || v.includes('upload.cloudlift.app') || v.includes('cloudlift.app')) {
        props[k] = v;
      }
    });

    return props;
  }

  function getVisibleLiftFileRows() {
    return Array.from(document.querySelectorAll('.filepond--item')).filter(item => {
      const text = (item.textContent || '').trim();
      return !!text;
    });
  }

  function getVisibleLiftFileName(item, fallbackIndex) {
    const raw =
      item.querySelector('.filepond--file-info-main')?.textContent ||
      item.querySelector('.filepond--file-info')?.textContent ||
      item.textContent ||
      '';

    const lines = raw.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
    const name = lines.find(line =>
      !/upload complete|tap to undo|tap to cancel|processing complete|remove|uploading|loading|retry/i.test(line)
    );

    return name || `File ${fallbackIndex}`;
  }

  function isRecoverableUploadUrl(value) {
    return /upload\.cloudlift\.app|storage\.googleapis\.com/i.test(value || '');
  }

  function getRecoverableSavedFileCandidates() {
    readUploadInputsIntoCache();

    const visibleRows = getVisibleLiftFileRows();
    if (!visibleRows.length) return { mode: 'none', files: [] };

    const byIndex = {};
    const nodes = document.querySelectorAll('input[name^="properties["],textarea[name^="properties["]');

    nodes.forEach(node => {
      const match = node.name.match(/^properties\[(.+)\]$/);
      if (!match) return;

      const key = match[1];
      const value = (node.value || '').trim();
      if (!value) return;

      let indexMatch = key.match(/^Blueprint Upload_(\d+)$/i);
      if (indexMatch && isRecoverableUploadUrl(value)) {
        const index = parseInt(indexMatch[1], 10);
        byIndex[index] = byIndex[index] || { index };
        byIndex[index].url = value;
        return;
      }

      indexMatch = key.match(/^_?Blueprint File (\d+) URL$/i);
      if (indexMatch && isRecoverableUploadUrl(value)) {
        const index = parseInt(indexMatch[1], 10);
        byIndex[index] = byIndex[index] || { index };
        byIndex[index].url = value;
        return;
      }

      indexMatch = key.match(/^Blueprint File (\d+)$/i);
      if (indexMatch) {
        const index = parseInt(indexMatch[1], 10);
        byIndex[index] = byIndex[index] || { index };
        byIndex[index].filename = value;
      }
    });

    const recovered = Object.keys(byIndex)
      .map(key => byIndex[key])
      .filter(file => file && file.url)
      .sort((a, b) => a.index - b.index);

    if (!recovered.length) return { mode: 'fallback', files: [] };

   if (recovered.length !== visibleRows.length) {
      return { mode: 'fallback', files: [] };
    }

    const files = recovered.map((file, idx) => ({
      index: file.index,
      url: file.url,
      label: `File ${idx + 1}`,
      filename: file.filename || getVisibleLiftFileName(visibleRows[idx], idx + 1)
    }));

    if (files.some(file => !file.url || !file.filename)) {
      return { mode: 'fallback', files: [] };
    }

    return { mode: 'confirm', files };
  }

  function showSavedFilesNotice(mode) {
    const warn = document.getElementById('stale-file-warning');
    if (!warn) return;
    const uploadPricingCopy = document.getElementById('upload-pricing-copy');
    const visibleRows = getVisibleLiftFileRows();
    const visibleNames = visibleRows.map((item, idx) => getVisibleLiftFileName(item, idx + 1));
    const savedNames = (pendingRecoveredFiles || []).map(file => (file && file.filename ? file.filename : '')).filter(Boolean);
    const displayNames = (savedNames.length ? savedNames : visibleNames).slice(0, 4);
    
function clearSavedFileFallback(index, targetUrl, survivors) {
      const nodes = document.querySelectorAll('input[name^="properties["],textarea[name^="properties["]');

      // Determine which saved-file slot to clear. Prefer the exact URL of the
      // file being removed, so this stays correct even after earlier deletions
      // have left the remaining files on non-sequential slot numbers.
      let slot = index + 1;
      if (targetUrl) {
        nodes.forEach(node => {
          if ((node.value || '').trim() !== targetUrl) return;
          const m = node.name.match(/^properties\[(?:Blueprint Upload_|_?Blueprint File )(\d+)(?: URL)?\]$/i);
          if (m) slot = parseInt(m[1], 10);
        });
      }

      nodes.forEach(node => {
        const match = node.name.match(/^properties\[(.+)\]$/);
        if (!match) return;

        const key = match[1];
        if (
          new RegExp(`^Blueprint Upload_${slot}$`, 'i').test(key) ||
          new RegExp(`^_?Blueprint File ${slot} URL$`, 'i').test(key) ||
          new RegExp(`^Blueprint File ${slot}$`, 'i').test(key) ||
          new RegExp(`^thumbnail_${slot}$`, 'i').test(key) ||
          (targetUrl && (node.value || '').trim() === targetUrl)
        ) {
          node.value = '';
        }
      });

      if (window.uploadPropsCache) {
        delete window.uploadPropsCache[`Blueprint Upload_${slot}`];
        delete window.uploadPropsCache[`Blueprint File ${slot}`];
        delete window.uploadPropsCache[`_Blueprint File ${slot} URL`];
        delete window.uploadPropsCache[`thumbnail_${slot}`];
      }

 // Survivors are snapshotted at click time (passed in) so a racing
      // upload:removed event can't empty the list before we get here. Recompute
      // only if no snapshot was provided (defensive; no caller does this today).
      survivors = survivors || (pendingRecoveredFiles || [])
        .filter(f => f && f.url && f.url !== targetUrl)
        .map((f, i) => ({ ...f, index: i + 1, label: `File ${i + 1}` }));

      uploadedFiles = [];
      totalPages = 0;
      pageCount = 0;
      savedFilesRecoveryFailed = false;
      recoveredFilesConfirmed = false;
      saveState();

      // Files remain and we still know their URLs -> re-show the full
      // "Use These Files" (confirm) banner for them.
      if (survivors.length) {
        pendingRecoveredFiles = survivors;
        savedFilesRecoveryFailed = false;
        showSavedFilesNotice('confirm');
        return;
      }

      // Only re-derive from the DOM if we had NO known URL list to begin with
      // (i.e. a deletion made from the button-less fallback banner).
      const remainingRows = getVisibleLiftFileRows();
      if (!targetUrl && remainingRows.length) {
        const recovery = getRecoverableSavedFileCandidates();
        pendingRecoveredFiles = recovery.mode === 'confirm' ? recovery.files : [];
        savedFilesRecoveryFailed = recovery.mode !== 'confirm';
        showSavedFilesNotice(recovery.mode === 'confirm' ? 'confirm' : 'fallback');
        return;
      }

      // Nothing left — clear the saved session and show a fresh upload box.
      pendingRecoveredFiles = [];
      clearUploadSession();
      window.__bpSkipStaleCheck = true;
      armFreshUploadEvents();
      renderStep(1);
    }

function removeVisibleFileAtIndex(index) {
      // Deleting churns the upload box; block the "Uploading…" reassurance so it
      // can't fire from that churn.
      window.__bpSuppressUploadingMsg = true;
      setTimeout(function () { window.__bpSuppressUploadingMsg = false; }, 2000);

      const targetUrl = (pendingRecoveredFiles[index] && pendingRecoveredFiles[index].url) || null;

      // Snapshot the survivors NOW, synchronously at click time. Upload-Lift's
      // own upload:removed event fires ~120ms after removeBtn.click() and empties
      // pendingRecoveredFiles before clearSavedFileFallback (~450ms) reads it —
      // which was dropping the survivor to a bare upload box. Capturing here
      // makes the survivor list immune to that race.
      const survivorsSnapshot = (pendingRecoveredFiles || [])
        .filter(f => f && f.url && f.url !== targetUrl)
        .map((f, i) => ({ ...f, index: i + 1, label: `File ${i + 1}` }));

      setTimeout(() => {
        const freshRows = getVisibleLiftFileRows();
        const row = freshRows[index];

        const removeBtn = row && (
          row.querySelector('.filepond--action-remove-item') ||
          row.querySelector('.filepond--action-revert-item-processing') ||
          row.querySelector('.filepond--action-abort-item-load') ||
          row.querySelector('.filepond--action-abort-item-processing') ||
          row.querySelector('button[aria-label*="remove" i]') ||
          row.querySelector('button[aria-label*="undo" i]') ||
          row.querySelector('button[title*="remove" i]') ||
          row.querySelector('button[title*="undo" i]') ||
          row.querySelector('button')
        );

        if (removeBtn) {
          removeBtn.click();

          setTimeout(() => {
            const stillThere = getVisibleLiftFileRows()[index];
            if (stillThere && stillThere.parentNode) {
              stillThere.parentNode.removeChild(stillThere);
            }
            clearSavedFileFallback(index, targetUrl, survivorsSnapshot);
          }, 450);

          return;
        }

        if (row && row.parentNode) row.parentNode.removeChild(row);
        clearSavedFileFallback(index, targetUrl, survivorsSnapshot);
      }, 300);
    }

    function bindSavedFileControls() {
      document.querySelectorAll('.saved-file-remove-btn').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const idx = parseInt(btn.getAttribute('data-file-index'), 10);
          if (!Number.isNaN(idx)) removeVisibleFileAtIndex(idx);
        });
      });
    }

    const namesHtml = displayNames.length
      ? `<div style="display:flex; flex-direction:column; align-items:center; gap:0.35rem; width:100%; max-width:620px;">
          ${displayNames.map((name, idx) => `<div style="width:100%; display:flex; align-items:center; gap:0.75rem; padding:0.55rem 0.8rem; background:#ffffff; border:1px solid #bfdbfe; border-radius:8px;">
            <div style="flex:1; font-size:0.95rem; font-weight:700; line-height:1.3; color:#1E3A8A; word-break:break-word; text-align:left;">${name}</div>
            <button
              type="button"
              class="saved-file-remove-btn"
              data-file-index="${idx}"
              aria-label="Remove saved file ${name}"
              style="width:30px; height:30px; flex:0 0 30px; border:none; border-radius:999px; background:#111111; color:#ffffff; font-size:0.95rem; font-weight:900; line-height:1; cursor:pointer;"
            >X</button>
          </div>`).join('')}
        </div>`
      : '';

    if (uploadPricingCopy) uploadPricingCopy.style.display = 'none';
    hideUploadBox();

    warn.style.display = 'block';
    warn.style.background = '#eff6ff';
    warn.style.border = '2px solid #93c5fd';
    warn.style.color = '#1E3A8A';
    warn.style.padding = '1.1rem 1.25rem';

if (mode === 'confirm') {
  warn.innerHTML = `
    <div style="display:flex; flex-direction:column; align-items:center; gap:0.7rem; text-align:center;">
      <div style="font-size:1.35rem; font-weight:800; line-height:1.1; color:#1E3A8A;">We saved your last blueprint upload</div>
      ${namesHtml}
      <div style="font-size:1.08rem; line-height:1.5; color:#1f2937; max-width:620px;">
        Reorder your last uploads by clicking "Print These Files."<br>
        Or, click the black <strong>X</strong> and upload new files.
      </div>
      <button
        type="button"
        id="use-saved-files-btn"
        class="btn-primary"
        style="padding:0.8rem 1.8rem; min-width:220px; font-size:1.12rem; line-height:1.15; background:#1E3A8A; color:#fff; border:none; border-radius:8px; font-weight:800; cursor:pointer; box-shadow:0 4px 12px rgba(30,58,138,0.18);"
      >
        Print These Files
        <span style="display:block; margin-top:0.2rem; font-size:0.72rem; font-weight:600; opacity:0.9;">(click here)</span>
      </button>
    </div>`;

  bindSavedFileControls();
  document.getElementById('use-saved-files-btn')?.addEventListener('click', confirmSavedFilesRecovery);
  return;
}

    warn.innerHTML = `
      <div style="display:flex; flex-direction:column; align-items:center; gap:0.55rem; text-align:center;">
        <div style="font-size:1.25rem; font-weight:800; line-height:1.1; color:#1E3A8A;">Saved Files Found</div>
        ${namesHtml}
        <div style="font-size:1rem; line-height:1.45; color:#1f2937; max-width:760px;">
          If you do not need these file(s), click the <strong>X</strong> below to remove them and upload new ones.
        </div>
      </div>`;
    bindSavedFileControls();
  }

  async function confirmSavedFilesRecovery() {
    if (recoveringSavedFiles || !pendingRecoveredFiles.length) return;
    recoveringSavedFiles = true;

    const container = document.getElementById("steps-container");
    if (container) {
      container.innerHTML = `<div class="detecting-pages" style="background:#fff3cd; border:2px solid #facc15; color:#92400e; text-align:center; padding:1rem; border-radius:8px; margin:1rem 0; font-size:1.05rem; font-weight:700;">Please wait - checking your saved files and counting pages...</div>`;
      container.classList.remove('hidden');
    }

    try {
      const recovered = [];

      for (const file of pendingRecoveredFiles) {
        const filename = (file.filename || '').trim();
        if (!/\.pdf$/i.test(filename)) {
          savedFilesRecoveryFailed = true;
          pendingRecoveredFiles = [];
          recoveredFilesConfirmed = false;
          renderStep(1);
          return;
        }

 const pdfResult = await detectPDFPages(file.url);
        const detectedPages = pdfResult ? pdfResult.pageCount : null;
        const detectedSize = pdfResult && pdfResult.pageSizes.length ? detectMostCommonSize(pdfResult.pageSizes) : null;
        const resolvedSize = pdfResult && pdfResult.pageSizes.length ? resolveUploadedSize(dominantRawSize(pdfResult.pageSizes)) : null;

        if (!(detectedPages > 0)) {
          savedFilesRecoveryFailed = true;
          pendingRecoveredFiles = [];
          recoveredFilesConfirmed = false;
          renderStep(1);
          return;
        }

    recovered.push({
          url: file.url,
          label: file.label || filename,
          pages: detectedPages,
          filename,
          detectedSize,
          resolved: resolvedSize
        });
      }

      uploadedFiles = recovered;
      totalPages = uploadedFiles.reduce((sum, file) => sum + (file.pages || 0), 0);
      waitingForUpload = true;
      pageDetectionAttempted = true;
      recoveredFilesConfirmed = true;
      savedFilesRecoveryFailed = false;
      pendingRecoveredFiles = [];
      readUploadInputsIntoCache();
      saveUploadSession();
      renderUploadStep();
    } finally {
      recoveringSavedFiles = false;
    }
  }

function getUploadBoxRoot() {
  return (
    document.querySelector('.filepond--root') ||
    document.querySelector('.upload-lift') ||
    document.querySelector('.shopify-block-upload-lift') ||
    document.querySelector('[class*="upload"]')
  );
}

function showUploadBox(attempts = 0) {
  if (attempts === 0) window.__bpUploadBoxWanted = true;
  // A hideUploadBox() call (e.g. the saved-files banner) cancels pending retries.
  if (!window.__bpUploadBoxWanted) return;

  const pondRoot = document.querySelector('.filepond--root');

  if (pondRoot) {
    pondRoot.classList.add('show-upload');
    pondRoot.style.opacity = '1';
    pondRoot.style.pointerEvents = 'auto';
    pondRoot.style.maxHeight = '1200px';
  }

  const fallbackRoot = getUploadBoxRoot();
  if (fallbackRoot && fallbackRoot !== pondRoot) {
    fallbackRoot.classList.add('show-upload');
    fallbackRoot.style.opacity = '1';
    fallbackRoot.style.pointerEvents = 'auto';
    fallbackRoot.style.maxHeight = '1200px';
  }

  if (!pondRoot && attempts < 80 && window.__bpUploadBoxWanted) {
    setTimeout(() => showUploadBox(attempts + 1), 50);
  }
}

function hideUploadBox() {
  // Cancel any in-flight showUploadBox() retry loop so a late FilePond mount
  // can't re-show the box after we've hidden it (the "both boxes" bug).
  window.__bpUploadBoxWanted = false;

  const roots = [];
  const pondRoot = document.querySelector('.filepond--root');
  if (pondRoot) roots.push(pondRoot);

  const fallbackRoot = getUploadBoxRoot();
  if (fallbackRoot && fallbackRoot !== pondRoot) roots.push(fallbackRoot);

  roots.forEach(root => {
    root.classList.remove('show-upload');
    root.style.opacity = '0';
    root.style.pointerEvents = 'none';
    root.style.maxHeight = '0';
  });
}

function armFreshUploadEvents() {
  acceptUploadEvents = true;
}

function disarmFreshUploadEvents() {
  acceptUploadEvents = false;
}

  // Bug F: reassure the customer WHILE a file uploads (before it completes), so
  // they don't refresh / tap back / re-click the ad mid-upload and strand files.
  // Show reassurance for a genuine fresh upload start.
  // Keep this tied to click-to-select only. A raw drag/drop event can fire
  // before Upload-Lift actually accepts the file, which was leaving the wizard
  // stuck on the yellow uploading message.
  function showUploadingReassurance() {
    if (window.__bpSuppressUploadingMsg) return;             // a delete is in progress
    const c = document.getElementById('steps-container');
    if (!c) return;
    if (document.getElementById('bp-uploading-msg')) return; // already showing
    if (uploadedFiles && uploadedFiles.length > 0) return;   // a file already finished
    c.innerHTML = `<div id="bp-uploading-msg" class="detecting-pages" style="background:#fff3cd; border:2px solid #facc15; color:#92400e; text-align:center; padding:1.1rem; border-radius:8px; margin:1rem 0; font-size:1.1rem; font-weight:800;">
      Uploading your blueprint(s)...
      <div style="font-weight:600; font-size:0.98rem; margin-top:0.45rem;">Large plan sets can take a moment. Please keep this page open -- don't refresh or tap back.</div>
    </div>`;
    document.querySelector('.blueprint-wizard')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Watch for a file entering the upload box on click-to-select only.
  // Drag/drop is intentionally left alone so Upload-Lift/FilePond can finish
  // accepting the file before our wizard reacts.
  (function watchUploadStart() {
    function maybeShow() {
      if (!acceptUploadEvents || !waitingForUpload || currentStep !== 1) return;
      showUploadingReassurance();
    }

    document.addEventListener('change', function (e) {
      const t = e.target;
      if (t && t.matches && t.matches('input[type="file"]') &&
          t.files && t.files.length &&
          t.closest && (t.closest('.filepond--root') || t.closest('[class*="upload"]'))) {
        maybeShow();
      }
    }, true);
  })();

  document.addEventListener('upload:added', async (e) => {
    try {
      const d = e.detail || {};
      if (d.label && d.url) uploadPropsCache[d.label] = d.url;
      if (d.thumbUrl) uploadPropsCache.thumbnail = d.thumbUrl;

      if (!acceptUploadEvents) return;

      pendingRecoveredFiles = [];
      savedFilesRecoveryFailed = false;
      recoveredFilesConfirmed = false;

      if (waitingForUpload && currentStep === 1 && !window.__newWizardHandled) {

        const pdfUrl = d.url || null;
        if (!pdfUrl) {
         
          return;
        }

                const container = document.getElementById("steps-container");
        container.innerHTML = `<div class="detecting-pages" style="background:#fff3cd; border:2px solid #facc15; color:#92400e; text-align:center; padding:1rem; border-radius:8px; margin:1rem 0; font-size:1.05rem; font-weight:700;">⏳ Please wait — reading your file and counting pages...</div>`;
        container.classList.remove('hidden');

        document.querySelector('.blueprint-wizard')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      const pdfResult = await detectPDFPages(pdfUrl);
        const detectedPages = pdfResult ? pdfResult.pageCount : null;
        const detectedSize = pdfResult && pdfResult.pageSizes.length ? detectMostCommonSize(pdfResult.pageSizes) : null;
        const resolvedSize = pdfResult && pdfResult.pageSizes.length ? resolveUploadedSize(dominantRawSize(pdfResult.pageSizes)) : null;

        if (detectedPages && detectedPages > 0) {
          const filenameFromEvent =
  (d.file && d.file.name) ||
  d.filename ||
  d.name ||
  '';

const filenameFallbackFromUrl = (u) => {
  try {
    const clean = (u || '').split('?')[0];
    const last = clean.substring(clean.lastIndexOf('/') + 1);
    return decodeURIComponent(last || '').trim();
  } catch (_) {
    return '';
  }
};

const finalFilename = (filenameFromEvent || filenameFallbackFromUrl(pdfUrl) || (d.label || `File ${uploadedFiles.length + 1}`)).trim();

const fileExists = uploadedFiles.some(f => f.url === pdfUrl);
if (!fileExists) {
uploadedFiles.push({
    url: pdfUrl,
    label: d.label || `File ${uploadedFiles.length + 1}`,
    pages: detectedPages,
    filename: finalFilename,
    detectedSize: detectedSize,
    resolved: resolvedSize
  });
}

        totalPages = uploadedFiles.reduce((sum, file) => sum + file.pages, 0);

          const warn = document.getElementById('stale-file-warning');
          if (warn) warn.style.display = 'none';

          saveUploadSession();
          renderUploadStep();
        } else {
      
          const fileExists = uploadedFiles.some(f => f.url === pdfUrl);
          if (!fileExists) {
            uploadedFiles.push({
              url: pdfUrl,
              label: d.label || `File ${uploadedFiles.length + 1}`,
              pages: 0
            });
          }
          totalPages = uploadedFiles.reduce((sum, file) => sum + (file.pages || 0), 0);

          const warn = document.getElementById('stale-file-warning');
          if (warn) warn.style.display = 'none';

          saveUploadSession();
          renderUploadStep();
        }
      }
    } catch (err) {
      console.error('Upload handling error:', err);
    }
  });

document.addEventListener('upload:removed', (e) => {
    try {
      window.__bpSuppressUploadingMsg = true;
      setTimeout(function () { window.__bpSuppressUploadingMsg = false; }, 2000);
      const d = e.detail || {};
      if (d.label) delete uploadPropsCache[d.label];

      const savedFilesBannerVisible =
        currentStep === 1 &&
        (!uploadedFiles || uploadedFiles.length === 0) &&
        document.getElementById('stale-file-warning') &&
        document.getElementById('stale-file-warning').style.display !== 'none';

      if (savedFilesBannerVisible) {
        const uploadPricingCopy = document.getElementById('upload-pricing-copy');
        const warn = document.getElementById('stale-file-warning');

        setTimeout(() => {
          const remainingRows = getVisibleLiftFileRows();

          if (!remainingRows.length) {
            pendingRecoveredFiles = [];
            savedFilesRecoveryFailed = false;
            recoveredFilesConfirmed = false;
            if (warn) warn.style.display = 'none';
            if (uploadPricingCopy) uploadPricingCopy.style.display = '';
            armFreshUploadEvents();
            showUploadBox();
            return;
          }

          const recovery = getRecoverableSavedFileCandidates();
          pendingRecoveredFiles = recovery.mode === 'confirm' ? recovery.files : [];
          savedFilesRecoveryFailed = recovery.mode !== 'confirm';

          if (recovery.mode === 'confirm') {
            if (uploadPricingCopy) uploadPricingCopy.style.display = 'none';
            showSavedFilesNotice('confirm');
            return;
          }

          disarmFreshUploadEvents();
          showSavedFilesNotice('fallback');
        }, 120);

        return;
      }

      if (d.url) {
        uploadedFiles = (uploadedFiles || []).filter(f => f && f.url !== d.url);
        totalPages = uploadedFiles.reduce((sum, file) => sum + (file.pages || 0), 0);
        if (!uploadedFiles.length) {
          recoveredFilesConfirmed = false;
          pendingRecoveredFiles = [];
          savedFilesRecoveryFailed = false;
        }
        saveUploadSession();
        
        if (waitingForUpload && currentStep === 1) renderUploadStep();
      }
    } catch (_) {}
  });

function renderUploadStep() {
  const container = document.getElementById("steps-container");
 const recoveredMessage = recoveredFilesConfirmed
    ? `<p style="font-size:1.05rem; color:#1E3A8A; font-weight:700; margin:0 0 1rem;">Using your saved file(s). Review the details below, then choose your page size.</p>`
    : '';
  
  let fileListHTML = '';
  
  if (uploadedFiles.length > 0) {
    fileListHTML = '<div style="background:#f0f9ff; padding:1rem; border-radius:8px; margin:1rem 0;">';
     uploadedFiles.forEach((file, index) => {
      const displayName = file.filename || file.label || 'File ' + (index + 1);
      const detectedSz = file.detectedSize || selectedSize || null;
      const formattedSize = (file.resolved && file.resolved.displayLabel)
        ? file.resolved.displayLabel
        : (detectedSz ? detectedSz.replace('x', '" x ') + '"' : 'Select size on next screen');
      
      fileListHTML += `
        <div style="padding:0.5rem 0; border-bottom:1px solid #e0e7ff;">
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <span style="font-size:0.95rem; color:#333;">📄 ${displayName}</span>
            <span style="font-size:0.95rem; font-weight:600; color:#1E3A8A;">${file.pages} page${file.pages !== 1 ? 's' : ''}</span>
          </div>
          <div style="font-size:1.1rem; color:#666; margin-top:0.25rem; font-style:italic;">
            Blueprint page size detected: ${formattedSize}
          </div>
        </div>`;
    });
    
    const detectedSz = uploadedFiles.length > 0 ? (uploadedFiles[0].detectedSize || null) : null;
    
    fileListHTML += `
      <div style="margin-top:0.75rem; padding-top:0.75rem; border-top:2px solid #1E3A8A;">
        <div style="display:flex; justify-content:space-between; align-items:center;">
          <span style="font-size:1.1rem; font-weight:700; color:#1E3A8A;">Total Pages In Upload:</span>
          <span style="font-size:1.2rem; font-weight:800; color:#1E3A8A;">${totalPages} page${totalPages !== 1 ? 's' : ''}</span>
        </div>
        
      </div>
    </div>`;
  }
  
 container.innerHTML = `
  <div style="text-align:center; padding: 1rem 2rem 0rem 2rem; margin-bottom:-1rem;">
  ${uploadedFiles.length > 0 ? `
    <h2 style="color:#15803d; font-size:1.75rem; font-weight:800; margin-bottom:0.5rem;">
      ✓ ${uploadedFiles.length > 1 ? 'Your Files Are' : 'Your File Is'} Ready - Finish Your Order
    </h2>
    ${recoveredMessage}
  ` : `
    <h2 style="color:#1E3A8A; font-size:2.2rem; font-weight:800; margin-bottom:0.25rem;">
      Blueprints Printed Fast</h2>
    <p style="font-size:1.1rem; color:#374151; font-weight:800; margin-top:0; margin-bottom:1rem;">
      ${getDynamicShipMessage()}
    </p>
    <p style="font-size:1.5rem; color:#333; margin-bottom:1rem;">
   <span style="color:#b91c1c; font-weight:800;"></span> Upload your blueprints to get instant pricing 
</p>  `}

    ${fileListHTML}

    ${uploadedFiles.length > 0 ? `
  <div class="done-uploading-wrap" style="text-align:center; margin-top:1.5rem;">
    <button
      type="button"
      id="done-uploading-btn"
      class="btn-primary"
      style="
        padding:1rem 2.5rem;
        font-size:1.2rem;
        margin-top:1rem;
        background:#16A34A;
        color:#ffffff;
        border:none;
        border-radius:8px;
        font-weight:700;
        cursor:pointer;
        box-shadow:0 4px 14px rgba(0,0,0,0.15);
      "
    >
      Choose A Page Size For The Uploaded Files<br>
      <span style="font-size:1.15rem; font-weight:400; opacity:0.85;">(Click Here)</span>
    </button>
    <p style="margin-top:0.75rem; font-size:1.05rem; color:#1E3A8A; font-weight:700;">📎 Need to upload more files? Use the blue box below.</p>
  </div>
` : ''}
  </div>`;
  
if (uploadedFiles.length > 0) {
    // The ready screen tells the customer to "use the blue box below" to add
    // more files, so the Upload-Lift box must be visible and listening here.
    armFreshUploadEvents();
    showUploadBox();

    const doneBtn = document.getElementById('done-uploading-btn');
    if (doneBtn) {
      doneBtn.addEventListener('click', () => {
        pageCount = totalPages;
        waitingForUpload = false;
        pageDetectionAttempted = true;
        hideUploadBox();
        saveState();
        readUploadInputsIntoCache();

        const container = document.getElementById("steps-container");
        container.innerHTML = `<div class="detecting-pages" style="background:#dcfce7; color:#15803d;">✓ ${uploadedFiles.length} file${uploadedFiles.length !== 1 ? 's' : ''} uploaded - ${totalPages} total page${totalPages !== 1 ? 's' : ''}</div>`;

        window.scrollTo({ top: Math.max(0, window.pageYOffset - 30), behavior: 'smooth' });

        setTimeout(() => {
          nextStep(2);
        }, 100);
      });
    }
  }
}

function nextStep(step) {
  currentStep = step;
  saveState();
  if (step !== 1) hideUploadBox();
  document.body.classList.remove('bp-step-2');
  if (step === 2) document.body.classList.add('bp-step-2');
  document.getElementById("steps-container")?.classList.remove('hidden');
  renderStep(step);
}
  function renderStep(step) {
    const container = document.getElementById("steps-container");
    container.innerHTML = "";

if (step === 1) {
      waitingForUpload = true;
      uploadedFiles = [];
      totalPages = 0;
      recoveredFilesConfirmed = false;
      window.uploadPropsCache = {};
      container.innerHTML = `
<div style="text-align:center; padding: 1rem 2rem 0rem 2rem; margin-bottom:-1rem; max-width:1200px; margin-left:auto; margin-right:auto;">
  <h2 style="color:#1E3A8A; font-size:2.40rem; font-weight:800; margin-bottom:0.25rem; margin-top:-2.2rem;">
    Blueprints Printed Fast
  </h2>
  <p style="font-size:1.1rem; color:#374151; font-weight:700; margin-top:0; margin-bottom:1rem;">
    ${getDynamicShipMessage()}
  </p>
  <div style="text-align:center; margin:0.3rem 0 0.25rem 0;">
    <img 
      src="https://cdn.shopify.com/s/files/1/0710/6838/5476/files/BLUEPRINTS_03f18f53-ee7f-4b05-8340-380eda3c4379.jpg?v=1752662121" 
      alt="Blueprint printing" 
      style="max-width:380px; width:100%; height:115px; object-fit:cover; border-radius:12px; margin:0 auto; display:block; box-shadow:0 4px 12px rgba(0,0,0,0.15);"
    />
  </div>
  ${(allOrders && allOrders.length > 0) ? `
  <div style="text-align:center; margin:0.6rem 0 0.5rem;">
    <button type="button" id="back-to-review-btn"
      style="padding:0.55rem 1.2rem; font-size:0.95rem; background:#1E3A8A; color:#fff; border:none; border-radius:8px; font-weight:700; cursor:pointer; box-shadow:0 3px 9px rgba(30,58,138,0.15);">
      ← Back to My Order (Review &amp; Checkout)
    </button>
  </div>
  ` : ''}

  <p id="upload-pricing-copy" style="font-size:1.5rem; color:#333; margin-top:0.95rem; margin-bottom:0.1rem; max-width:800px; margin-left:auto; margin-right:auto; line-height:1.2;">
    <span style="color:#b91c1c; font-weight:500;"></span> ${(allOrders && allOrders.length > 0) ? 'Upload another blueprint set below' : 'Upload your blueprints to get instant pricing'}
  </p>
 
<div id="stale-file-warning" style="display:none; margin-top:1rem; padding:0.75rem 1rem; background:#fff3cd; border:2px solid #facc15; border-radius:8px; font-size:0.95rem; color:#000; font-weight:600;">
    Saved files notice
  </div>
</div>`;

      document.getElementById('back-to-review-btn')?.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Customer changed their mind about adding more — return to the existing
        // order without adding anything, so a buy-ready order is never a dead end.
        window.__addingMoreFiles = false;
        hideUploadBox();
        uploadedFiles = [];
        totalPages = 0;
        waitingForUpload = false;
        pendingRecoveredFiles = [];
        savedFilesRecoveryFailed = false;
        recoveredFilesConfirmed = false;
        selectedSize = null;
        selectedVariant = null;
        pageCount = 0;
        currentStep = 7;
        document.getElementById('step-1')?.classList.add('hidden');
        document.getElementById('steps-container')?.classList.remove('hidden');
        saveState();
        renderReviewSummary();
      });

      disarmFreshUploadEvents();
      showUploadBox();

if (window.__bpSkipStaleCheck) {
        window.__bpSkipStaleCheck = false;
        const warnEl = document.getElementById('stale-file-warning');
        if (warnEl) { warnEl.style.display = 'none'; warnEl.innerHTML = ''; }
        armFreshUploadEvents();
        showUploadBox();
        return;
      }

      let staleCheckAttempts = 0;
      const runStaleCheck = () => {
        const pondReady = document.querySelector('.filepond--root') !== null;
        const hasItems = document.querySelector('.filepond--item') !== null;

        if (!pondReady && staleCheckAttempts < 25) {
          staleCheckAttempts++;
          setTimeout(runStaleCheck, 100);
          return;
        }

        if (pondReady && !hasItems && staleCheckAttempts < 8) {
          staleCheckAttempts++;
          setTimeout(runStaleCheck, 100);
          return;
        }

const hasStale = hasItems;
        const hasGood = uploadedFiles.length > 0;

      if (window.__addingMoreFiles) {
        window.__addingMoreFiles = false;
        armFreshUploadEvents();
        showUploadBox();
        return;
      }

      if (hasStale && !hasGood) {
  if (savedFilesRecoveryFailed) {
    showSavedFilesNotice('fallback');
  } else {
    const recovery = getRecoverableSavedFileCandidates();
    pendingRecoveredFiles = recovery.mode === 'confirm' ? recovery.files : [];
    savedFilesRecoveryFailed = recovery.mode !== 'confirm';
    showSavedFilesNotice(recovery.mode === 'confirm' ? 'confirm' : 'fallback');
  }
  window.__addingMoreFiles = false;
  return;
}

 armFreshUploadEvents();
        window.__addingMoreFiles = false;
      };
      runStaleCheck();

      return;
    }

if (step === 2) {
  document.getElementById('steps-container')?.classList.add('hidden');
  document.getElementById('step-1')?.classList.remove('hidden');

  const firstCard = document.querySelector('.size-card');

  // Capture the original first card once and restore it before each size check.
  if (firstCard && typeof window.__bpFirstCardHTML === 'undefined') {
    window.__bpFirstCardHTML = firstCard.innerHTML;
    window.__bpFirstCardSize = firstCard.dataset.size;
  }

  if (firstCard && typeof window.__bpFirstCardHTML !== 'undefined') {
    firstCard.innerHTML = window.__bpFirstCardHTML;
    firstCard.dataset.size = window.__bpFirstCardSize;
    firstCard.removeAttribute('data-true-size');
  }

  const resolved = uploadedFiles.length > 0 ? uploadedFiles[0].resolved : null;
  let highlightKey = null;
  let highlightCard = null;

  if (resolved && resolved.relabel && firstCard) {
    const p = priceMap[resolved.sizeKey] != null
      ? priceMap[resolved.sizeKey].toFixed(2)
      : null;

    const labelSpan = firstCard.querySelector('.label');

    if (labelSpan) {
      labelSpan.innerHTML = `${resolved.displayLabel}${p ? `<span class="price">$${p} per page</span>` : ''}`;
    }

    firstCard.dataset.size = resolved.sizeKey;

    if (resolved.isCustom) {
      firstCard.setAttribute('data-true-size', resolved.trueLabel);
    }

    highlightKey = resolved.sizeKey;
    highlightCard = firstCard;
  } else if (resolved) {
    highlightKey = resolved.sizeKey;
  } else if (uploadedFiles.length > 0) {
    highlightKey = uploadedFiles[0].detectedSize || null;
  }

  const lbl = document.getElementById('detected-size-label');

  if (lbl) {
    lbl.textContent = resolved
      ? `Your file's size is ${resolved.displayLabel}`
      : (highlightKey ? `Your file's size is ${highlightKey.replace('x', '" x ')}" ` : '');
  }

  document.querySelectorAll('.size-card').forEach(card => {
    const shouldHighlight = highlightCard
      ? card === highlightCard
      : card.dataset.size === highlightKey;

    card.style.outline = shouldHighlight
      ? '4px solid #facc15'
      : 'none';

    card.style.outlineOffset = '2px';
  });

  return;
}
    if (step === 3) {
      container.innerHTML = `
        <style>
          .qty-row { display:grid; grid-template-columns:auto 1fr auto; align-items:center; gap:12px; max-width:360px; margin:0 auto; }
          .qty-row .btn-secondary { min-width:44px; min-height:44px; font-size:1.25rem; line-height:1; padding:0.5rem 0.75rem; }
          #page-count { width:100%; text-align:center; font-size:1.1rem; padding:0.6rem 0.75rem; }
          .button-group { display:flex; justify-content:center; margin-top:10px; }
          .helper { font-size:0.9rem; color:#555; text-align:center; margin:0.35rem 0 0.85rem; font-style:italic; }
.error { font-size:0.95rem; color:#b91c1c; text-align:center; margin-top:0.5rem; display:none; }
          .btn-primary[disabled] { opacity:0.6; cursor:not-allowed; }
          @media (max-width:480px){ .qty-row{ gap:10px; max-width:320px;} .qty-row .btn-secondary{ font-size:1.3rem;} #page-count{ font-size:1.05rem;} }
        </style>

        <h2>How many pages are <br> in your file?</h2>
        <div class="helper">We couldn't auto-detect the page count. Please enter it manually.</div>

        <div class="qty-row">
          <button type="button" id="pg-dec" class="btn-secondary" aria-label="decrease pages">–</button>
          <input id="page-count" type="number" inputmode="numeric" min="1" step="1" placeholder="Enter pages" aria-label="number of pages"/>
          <button type="button" id="pg-inc" class="btn-secondary" aria-label="increase pages">+</button>
        </div>

        <div id="page-error" class="error">Please enter at least 1 page.</div>

        <div class="button-group"><button type="button" id="to-step-4" class="btn-primary" disabled>Next</button></div>`;

      const input = document.getElementById('page-count');
      const nextBtn = document.getElementById('to-step-4');
      const err = document.getElementById('page-error');

      input.value = pageCount > 0 ? String(pageCount) : '';

      document.getElementById('pg-dec').addEventListener('click', () => { adjustCount('pages', -1); syncFromState(); });
      document.getElementById('pg-inc').addEventListener('click', () => { adjustCount('pages', 1);  syncFromState(); });

      input.addEventListener('input', (e) => {
        const v = e.target.value.replace(/[^\d]/g, '');
        e.target.value = v;
        pageCount = Math.max(parseInt(v || '0', 10), 0);
        saveState(); 
        validate();
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (pageCount > 0) nextStep(4);
        }
      });
    nextBtn.addEventListener('click', () => nextStep(4));

      validate();

      function validate() {
        const ok = pageCount > 0;
        nextBtn.disabled = !ok;
        err.style.display = ok ? 'none' : 'block';
      }

      function syncFromState() {
        input.value = pageCount > 0 ? String(pageCount) : '';
        validate();
      }
    }

        if (step === 4) {
      container.innerHTML = `
        <h2>How many copies <br> would you like printed?</h2>
        <div style="font-size:1.4rem; color:#555; text-align:center; margin:0.35rem 0 0.75rem; font-style:italic;">One copy = Your full PDF printed once.</div>
        <div class="button-group">
          <button type="button" onclick="adjustCount('sets', -1)" class="btn-secondary">–</button>
          <input id="set-count" type="text" inputmode="numeric" placeholder="Click/Add sets" style="width:120px;" />
          <button type="button" onclick="adjustCount('sets', 1)" class="btn-secondary">+</button>
        </div>
        <div class="button-group" style="margin-top:1rem;">
          <button type="button" id="back-to-step-3" class="btn-secondary" style="padding:0.55rem 1.1rem; font-size:1rem;">Back</button>
          <button type="button" id="to-step-5" class="btn-primary" style="padding:0.6rem 1.25rem; font-size:1.05rem;">Next</button>
        </div>`;
    document.getElementById('set-count').addEventListener('input', e => {
        setCount = parseInt(e.target.value) || 1;
        saveState(); 
      });
      document.getElementById('to-step-5').addEventListener('click', () => nextStep(5));
      document.getElementById('back-to-step-3').addEventListener('click', () => nextStep(2));
    }

    if (step === 5) {
      container.innerHTML = `
        <div style="text-align:center;">
          <h2 style="font-size:32px; line-height:1.2; font-weight:700;">
  Upgrade To Color Blueprints?
</h2>
          <p style="font-size:1.5rem; color:#374151; margin:0.5rem 0 2.5rem;">
            Print your plans in color. See every detail your crew needs — For just 40¢ more per page.<br> It's only <strong>$4 per 10 pages</strong>.
          </p>
          <div class="button-group" style="justify-content:center;">
            <button type="button" id="color-yes" class="btn-primary">Yes – Print In Color</button>
            <button type="button" id="color-no" class="btn-secondary" style="font-size:1rem;">No thanks, B&W is fine</button>
          </div>
        </div>`;
document.getElementById('color-yes').addEventListener('click', () => {
        isColorPrint = true;
        selectedVariant = VARIANT_BY_SIZE_COLOR[selectedSize];
        saveState();
        nextStep(7);
      });

      document.getElementById('color-no').addEventListener('click', () => {
        isColorPrint = false;
        selectedVariant = VARIANT_BY_SIZE_BW[selectedSize];
        saveState();
        nextStep(7);
      });
      
    }

    if (step === 7) {
      if (selectedSize && pageCount > 0) {
        allOrders.push({
          size: selectedSize,
          pages: pageCount,
          sets: setCount,
          color: isColorPrint,
          stapleBlueprints: false,
          variant: selectedVariant,
          uploadedFilesSnapshot: (uploadedFiles || []).filter(f => f && f.url).map(f => ({
            url: f.url || '',
            label: f.label || '',
            filename: f.filename || '',
            pages: typeof f.pages !== 'undefined' ? f.pages : 0
          }))
        });
        saveState();
      }
      selectedSize = null;
      selectedVariant = null;
      pageCount = 0;
      setCount = 2;
      pageDetectionAttempted = false;
      waitingForUpload = false;
      uploadedFiles = [];
      totalPages = 0;
      window.uploadPropsCache = {};
      saveState();
      renderReviewSummary();
    }

  } 

  function renderReviewSummary() {
    const container = document.getElementById("steps-container");

let grandTotal = 0;
let grandTotalPages = 0;

(allOrders || []).filter(o => o && o.size).forEach((order) => {
  const totalPages = order.pages * order.sets;
  const basePrice = priceMap[order.size] || 0;
  const colorPrice = colorPriceMap[order.size] || basePrice + 1.53;
  const costPerPage = order.color ? colorPrice : basePrice;
  grandTotal += totalPages * costPerPage;
  grandTotalPages += totalPages;
});
const grandSubtotal = grandTotal;
const isCommercialOrder = grandTotalPages >= 1 || grandSubtotal >= 2;
const discount = getBlueprintDiscount(grandSubtotal);
window.__bpDiscountCode = discount.code;
window.__bpDiscountPercent = discount.percent;
const grandTotalAfterDiscount = grandSubtotal * (1 - window.__bpDiscountPercent / 100);

let summaryLines = '';

(allOrders || []).filter(o => o && o.size).forEach((order, i) => {
  const formattedSize = (order.size || '').replace('x', '" x ') + '"';
  const basePrice = priceMap[order.size] || 0;
  const colorPrice = colorPriceMap[order.size] || basePrice + 1.53;

  const costPerPage = order.color ? colorPrice : basePrice;
  const discountedCostPerPage = costPerPage * (1 - window.__bpDiscountPercent / 100);

  summaryLines += `
    <div style="margin-bottom: 1.75rem;" data-order-index="${i}">

      <div style="display:flex; align-items:center; gap:10px; margin-bottom:6px;">
        <img 
          src="https://cdn.shopify.com/s/files/1/0710/6838/5476/files/BLUEPRINTS_03f18f53-ee7f-4b05-8340-380eda3c4379.jpg?v=1752662121"
          alt="Blueprint"
          style="width:50px; height:50px; object-fit:cover; border-radius:6px; flex-shrink:0;"
        />
                        <p style="font-size:1.18rem; color:#000; font-weight:800; margin:0;">
          Plan Set ${i + 1}
        </p>
      </div>

      ${order.uploadedFilesSnapshot && order.uploadedFilesSnapshot.length > 0 ? `
        <div style="margin:0 0 8px 0;">
          ${order.uploadedFilesSnapshot.map(file => {
            const displayName = file.filename || file.label || 'Blueprint file';
            return `<div style="font-size:1.18rem; color:#666; word-break:break-all;">📄 ${displayName}</div>`;
          }).join('')}
        </div>
      ` : ''}

      <p style="font-size:1.18rem; color:#1E3A8A; font-weight:700; margin:0;">
        <strong>${formattedSize}</strong>
      </p>

      <p style="font-size:1.18rem; color:#1E3A8A; font-weight:700; margin:4px 0 0;">
        <strong>${order.color ? 'Full Color' : 'Black & White'}</strong>
      </p>

      <p style="font-size:1.18rem; color:#1E3A8A; font-weight:600; margin:6px 0 0;">
        ${window.__bpDiscountPercent > 0
          ? `<span style="color:#b91c1c; text-decoration:line-through; margin-right:8px;">$${costPerPage.toFixed(2)}</span><span style="color:#15803d; font-weight:800;">$${discountedCostPerPage.toFixed(2)}</span> per page`
          : `$${costPerPage.toFixed(2)} per page`}
      </p>

      <p style="font-size:1.18rem; color:#1E3A8A; font-weight:600; margin:6px 0 0;">
        ${order.pages} Total page(s) in construction set
      </p>

      <p style="
    font-size:1.1rem;
    color:#15803d;
    margin:10px 0 6px 0;
    font-weight:700;
  ">
    ✔ Need copies for your crew or extra permit sets?
  </p>

<div style="display:flex; align-items:center; gap:10px; margin-top:8px;">
  <span style="font-size:0.95rem; font-weight:600; color:#374151;">Copies:</span>
 <button
    type="button"
    class="sets-dec-btn"
    data-index="${i}"
    style="width:42px; height:42px; font-size:1.4rem; font-weight:700; border-radius:8px; border:1px solid #ccc; background:#f3f4f6; cursor:pointer; line-height:1;"
  >–</button>
  <span class="sets-display" data-index="${i}" style="font-size:1.2rem; font-weight:700; color:#1E3A8A; min-width:32px; text-align:center;">
    ${order.sets}
  </span>
  <button
    type="button"
    class="sets-inc-btn"
    data-index="${i}"
    style="width:42px; height:42px; font-size:1.4rem; font-weight:700; border-radius:8px; border:1px solid #ccc; background:#f3f4f6; cursor:pointer; line-height:1;"
  >+</button>
</div>

<div style="margin-top:8px;">
  <label style="display:flex; align-items:center; gap:6px; font-size:0.9rem; font-weight:600; color:#1E3A8A; cursor:pointer; white-space:nowrap;">
    <input
      type="checkbox"
      class="staple-checkbox"
      data-index="${i}"
      ${order.stapleBlueprints ? 'checked' : ''}
      style="width:16px; height:16px;"
    />
    Staple blueprint sets
  </label>

  <div style="margin-top:12px;">
    <button
      type="button"
      class="remove-order-btn"
      data-index="${i}"
      title="Remove Plan Set ${i + 1}"
      style="background:none; border:none; color:#c00; cursor:pointer; font-size:1.05rem; font-weight:700; padding:0;"
    >🗑️ Remove Plan Set ${i + 1}</button>
  </div>

  <div style="
    margin-top:18px;
    border-top:2px solid #e5e7eb;
  "></div>
</div>
    </div>`;
});
    
        summaryLines += `
      <div style="margin-top:1.5rem; padding-top:1.25rem;">

      <div style="
        text-align:center;
        margin-bottom:1rem;
      ">
        <button
          type="button"
          id="edit-order-btn"
          style="
            font-size:1.05rem;
            opacity:0.85;
            background:none;
            border:none;
            text-decoration:underline;
            cursor:pointer;
            font-weight:600;
          "
        >
          + Add More Files/Sizes
        </button>
      </div>

       <div style="
         max-width:520px;
         border:1px solid #e5e7eb;
         border-radius:14px;
         padding:1.25rem;
         background:#fff;
       ">

       <div style="margin:0;">
  <p style="font-size:1.05rem; color:#111; font-weight:800; margin:0;">
    Order Total (pre tax)
  </p>

  ${window.__bpDiscountPercent > 0 ? `
    <p style="margin:0.25rem 0 0; font-weight:900; font-size:1.25rem;">
      <span style="color:#b91c1c; text-decoration:line-through; margin-right:10px;">$${grandSubtotal.toFixed(2)}</span>
      <span style="color:#15803d;">$${grandTotalAfterDiscount.toFixed(2)}</span>
    </p>
    <p style="margin:0.25rem 0 0; font-size:0.95rem; color:#15803d; font-style:italic;">
      ${window.__bpDiscountPercent}% off - Auto large order discount applied
    </p>
  ` : `
    <p style="font-size:1.25rem; color:#111; font-weight:900; margin:0.25rem 0 0;">
      $${grandTotal.toFixed(2)}
    </p>
  `}

  <p style="margin:0.65rem 0 0; color:#15803d; font-size:0.95rem; font-weight:800; line-height:1.35;">
    ${grandTotalAfterDiscount >= 150
      ? 'Free 2-day shipping is included with this order.'
      : grandTotalAfterDiscount >= 50
        ? grandSubtotal >= 150
          ? `Free ground shipping included. ${window.__bpDiscountPercent}% large-order savings applied.`
          : 'Free ground shipping included. Orders of $150+ earn 10% off.'
        : 'Shipping is only $5.53.'}
  </p>
</div>

<div style="margin-top:1rem;">
  <button
    type="button"
    id="place-order-btn-bottom"
    class="btn-primary"
    style="
      width:100%;
      padding:0.9rem 1.5rem;
      font-size:1.2rem;
      font-weight:700;
      border-radius:12px;
      box-shadow:0 6px 16px rgba(0,0,0,0.18);
    "
 >
    Print My Blueprints<br>
    <span style="font-size:0.75rem; font-weight:400; opacity:0.85;">(Checkout)</span>
  </button>
</div>

      </div>

      </div>`;

   container.innerHTML = `
      <div style="padding:1.25rem; background:#fff; border:2px solid #1E3A8A; border-radius:12px; max-width:1800px; margin:0 auto; box-sizing:border-box;">
  <style>
@media (min-width: 769px){
  .rev-info-column{
    padding-top:73px;
  }

  .rev-contact-block{
    margin-top:68px !important;
  }
}

@media (max-width: 768px){
  .rev-grid{ 
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }

  .rev-grid .button-group{
    flex-wrap: wrap !important;
    gap: 10px !important;
  }

  .rev-grid ul{
    font-size: 0.98rem !important;
    line-height: 1.35 !important;
  }

}
</style>
       <div class="rev-grid" style="display:grid; grid-template-columns:1fr 240px; gap:24px; align-items:start;">
  
      <div class="rev-order-column" style="padding-right:18px; padding-left:8px;">
  <h3 style="color:#1E3A8A; font-weight:600; margin:0 0 0 0; text-align:center; font-size:1.3rem; line-height:1.2;">Review your<br>blueprint order</h3>
  <hr style="border:none; border-top:1px solid #e5e7eb; margin:0.75rem 0 0.75rem;">
${isCommercialOrder ? `
  <div style="margin-bottom:10px;">
    <input id="bp-po-number" type="text" placeholder="Enter PO / Job Name (Optional)" style="width:72%; max-width:320px; padding:0.25rem 0.6rem; border:1px solid #ccc; border-radius:6px; font-size:0.75rem; box-sizing:border-box;"/>
  </div>
` : ''}
  
<div>${summaryLines}</div>
</div>

  <div class="rev-info-column">

<ul style="
  font-size:1rem;
  color:#333;
  margin-top:0;
  padding-left:0;
  list-style:none;
  max-width:800px;
  margin-inline:auto;
">
  <li style="margin-bottom:0.5rem; display:flex; align-items:center; gap:0.5rem;">
    <span style="color:#1E3A8A; font-weight:900;">✔</span>
    <strong>${getDynamicShipMessage()}</strong>
  </li>

  <li style="margin-bottom:0.5rem; display:flex; align-items:center; gap:0.5rem;">
    <span style="color:#1E3A8A; font-weight:900;">✔</span>
    <strong>${allOrders[0]?.pages >= 30 ? 'We give large plan sets an extra check before printing.' : 'Your plans will be checked for proper size and scale before printing.'}</strong>
  </li>

  <li style="margin-bottom:0.5rem; display:flex; align-items:center; gap:0.5rem;">
    <span style="color:#1E3A8A; font-weight:900;">✔</span>
    <strong>${grandTotalAfterDiscount >= 150 ? 'Free 2-day shipping is included.' : grandTotalAfterDiscount >= 50 ? 'Free ground shipping is included.' : 'Blueprints will arrive sealed and packaged for jobsite use.'}</strong>
  </li>

  ${grandTotalAfterDiscount >= 150 ? `
    <li style="margin-bottom:0.5rem; display:flex; align-items:center; gap:0.5rem;">
      <span style="color:#1E3A8A; font-weight:900;">✔</span>
      <strong>Estimated delivery date: ${getEstimatedDeliveryDate(2)}.</strong>
    </li>
  ` : grandTotalAfterDiscount < 50 ? `
    <li style="margin-bottom:0.5rem; display:flex; align-items:center; gap:0.5rem;">
      <span style="color:#1E3A8A; font-weight:900;">✔</span>
      <strong>Blueprint orders $50+ ship free.</strong>
    </li>
  ` : ''}

  <li style="display:flex; align-items:center; gap:0.5rem;">
    <span style="color:#1E3A8A; font-weight:900;">✔</span>
    <strong>On a deadline? Choose overnight shipping at checkout.</strong>
  </li>
</ul>

  <div class="button-group" style="
  margin-top:18px;
  display:flex;
  flex-direction:column;
  align-items:center;
">

  <div style="
    text-align:center;
    font-size:0.9rem;
    color:#4b5563;
    margin-bottom:10px;
    line-height:1.8;
  ">
    <div><strong>Questions? We're here to help. Call & speak with our print team.</strong></div>
    <div><a href="tel:8106323300" style="color:#1E3A8A; font-weight:700; text-decoration:none;">📞 810-632-3300</a></div>
    <div><a href="mailto:Team@OneShopMedia.com" style="color:#1E3A8A; font-weight:700; text-decoration:none;">✉️ Team@OneShopMedia.com</a></div>
  </div>

  <img 
    src="https://cdn.shopify.com/s/files/1/0710/6838/5476/files/VISAMASTERCARDIMAGE.jpg?v=1778072616"
    alt="Visa, MasterCard, Discover & AmEx accepted"
    style="width:100%; max-width:120px; display:block; margin:0 auto;"
  />

</div>
</div>

    </div>
      </div>`;
   document.querySelectorAll('.remove-order-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const index = parseInt(btn.getAttribute('data-index'));
    allOrders.splice(index, 1);
    saveState();
    renderReviewSummary();
  });
});

let copyButtonLocked = false;

function handleCopyChange(e, delta) {
  e.preventDefault();
  e.stopPropagation();

  if (copyButtonLocked) return;
  copyButtonLocked = true;

  setTimeout(() => {
    copyButtonLocked = false;
  }, 250);

  const btn = e.currentTarget;
  const index = parseInt(btn.getAttribute('data-index'), 10);

  if (!allOrders[index]) return;

  const currentSets = parseInt(allOrders[index].sets, 10) || 1;
  const nextSets = Math.max(1, currentSets + delta);

  if (nextSets === currentSets) return;

  const poVal = document.getElementById('bp-po-number')?.value || '';

  allOrders[index].sets = nextSets;
  saveState();
  renderReviewSummary();

  const poInput = document.getElementById('bp-po-number');
  if (poInput) poInput.value = poVal;
}

document.querySelectorAll('.sets-dec-btn').forEach(btn => {
  btn.addEventListener('click', (e) => handleCopyChange(e, -1));
});

document.querySelectorAll('.sets-inc-btn').forEach(btn => {
  btn.addEventListener('click', (e) => handleCopyChange(e, 1));
});

document.querySelectorAll('.staple-checkbox').forEach(cb => {
  cb.addEventListener('change', (e) => {
    e.stopPropagation();

    const index = parseInt(cb.getAttribute('data-index'), 10);
    if (!allOrders[index]) return;

    allOrders[index].stapleBlueprints = cb.checked;
    saveState();
  });
});

                            window.checkoutInProgress = false;

const checkoutHandler = async function (e) {
      e?.preventDefault();
      e?.stopPropagation();
      e?.stopImmediatePropagation();

      if (window.checkoutInProgress) return;
      window.checkoutInProgress = true;
      bpStep('Preparing your order...');

      const checkoutBtn = document.getElementById('place-order-btn-bottom');
      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.style.pointerEvents = 'none';
        checkoutBtn.innerHTML = 'Processing...';
      }

          try {
        bpStep('Checking order files...');

        const hasFiles = (allOrders || []).some(o =>
          (o.uploadedFilesSnapshot || []).some(f => f && f.url)
        );

                if (!hasFiles) {
          window.checkoutInProgress = false;
          if (checkoutBtn) {
            checkoutBtn.disabled = false;
            checkoutBtn.style.pointerEvents = 'auto';
            checkoutBtn.innerHTML = 'Print My Blueprints<br><span style="font-size:0.75rem; font-weight:400; opacity:0.85;">(Checkout)</span>';
          }
          alert('Please upload your blueprint file before checkout.');
          return;
        }

        const items = (allOrders || []).map(o => {
          const id = o.variant || null;
          const pages = parseInt(o.pages, 10) || 0;
          const sets = parseInt(o.sets, 10) || 0;
          const quantity = pages * sets;
          if (!id || quantity <= 0) return null;

          const perOrderFiles = (o.uploadedFilesSnapshot || []).filter(f => f && f.url);
          const uploadPropsPerOrder =
            perOrderFiles.length
              ? buildBlueprintUploadPropsFromUploadedFiles(perOrderFiles)
              : buildBlueprintUploadPropsFromCacheFallback();

          return {
            id,
            quantity,
            properties: {
              ...uploadPropsPerOrder,
              Size: o.size,
              'Full-Size Pages in Set': String(pages),
              'Total Copies / Plan Sets': String(sets),
              Color: o.color ? 'Yes' : 'No',
              'Staple Blueprints': o.stapleBlueprints ? 'Yes' : 'No',
              ...(document.getElementById('bp-po-number')?.value?.trim()
                ? {'PO #/Job': document.getElementById('bp-po-number').value.trim()}
                : {})
            }
          };
        }).filter(Boolean);

        if (!items.length) {
          alert('Nothing to add. Please add at least one blueprint order.');
          return;
        }

          const cartRoot = window.Shopify?.routes?.root || '/';
        bpStep('Preparing your blueprint order...');
        const clearResponse = await fetch(cartRoot + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin'
        });

        if (!clearResponse.ok) {
          bpStep('Cart issue — please click checkout again (clear ' + clearResponse.status + ')', true);
          throw new Error('Cart clear failed');
        }

             bpStep('Adding order to cart...');
        const addResponse = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });

           if (!addResponse.ok) {
          bpStep('Cart issue — please click checkout again (add ' + addResponse.status + ')', true);
          throw new Error('Cart add failed');
        }
        clearUploadSession();
        bpStep('Taking you to secure checkout...');

   var bpTarget = window.__bpDiscountPercent > 0
          ? `/discount/${window.__bpDiscountCode}?redirect=/checkout`
          : '/checkout';
        window.__bpStallTimer = setTimeout(function(){ bpStep('Checkout did not open — please tap checkout again. (stalled at: ' + bpTarget + ')', true); }, 10000);
        window.__bpExpectedCheckoutNav = true;
        window.location.href = bpTarget;


            } catch (e) {
        bpStep('Something went wrong — please click checkout again. (' + (e && e.message ? e.message : 'unknown') + ')', true);
        window.checkoutInProgress = false;
        const checkoutBtn = document.getElementById('place-order-btn-bottom');
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
          checkoutBtn.style.pointerEvents = 'auto';
          checkoutBtn.innerHTML = 'Print My Blueprints<br><span style="font-size:0.75rem; font-weight:400; opacity:0.85;">(Checkout)</span>';
        }

        console.error('Cart error:', e);
        alert('Something went wrong. Please click checkout again.');
      }
    };
  const checkoutBtn = document.getElementById('place-order-btn-bottom');
if (checkoutBtn) {
  checkoutBtn.addEventListener('click', checkoutHandler, true);
}
    document.getElementById('edit-order-btn')?.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const existingSticky = document.getElementById('sticky-checkout-bar');
  if (existingSticky) existingSticky.remove();

  window.__addingMoreFiles = true;
  uploadedFiles = [];
  totalPages = 0;
  pendingRecoveredFiles = [];
  savedFilesRecoveryFailed = false;
  recoveredFilesConfirmed = false;
  window.uploadPropsCache = {};
  saveState();
  nextStep(1);
});

    
  const existingSticky = document.getElementById('sticky-checkout-bar');
  if (existingSticky) existingSticky.remove();

  const stickyBar = document.createElement('div');
  stickyBar.id = 'sticky-checkout-bar';
  stickyBar.innerHTML = `
    <style>
      #sticky-checkout-bar {
        display: none;
        position: fixed;
        left: 20px;
        right: 20px;
        bottom: 16px;
        z-index: 9999;
      }

      @media (max-width: 768px) {
        #sticky-checkout-bar { display: block; }
      }

      #sticky-checkout-bar button {
        width: 100%;
        min-height: 70px;
        border: none;
        border-radius: 14px;
        background: #1E3A8A;
        color: #ffffff;
        font-size: 22px;
        font-weight: 900;
        line-height: 1.05;
        cursor: pointer;
        box-shadow: 0 10px 25px rgba(0,0,0,0.25);
      }

      #sticky-checkout-bar span {
        display:block;
        font-size:13px;
        font-weight:600;
        opacity:0.9;
        margin-top:5px;
      }
    </style>

    <button type="button" id="sticky-checkout-btn">
      Place Order
      <span>Secure checkout</span>
    </button>
  `;
  document.body.appendChild(stickyBar);

  document.getElementById('sticky-checkout-btn')?.addEventListener('click', (e) => {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  checkoutHandler(e);
}, true);

  } 

  window.adjustCount = function (type, delta) {
    const id = type === "pages" ? "page-count" : "set-count";
    const field = document.getElementById(id);
    const value = Math.max((parseInt(field?.value) || 0) + delta, type === "sets" ? 1 : 0);
    if (field) field.value = value;
    if (type === "pages") pageCount = value;
    else setCount = value;
    saveState(); 
  };

  window.renderReviewSummary = renderReviewSummary;
  window.saveState = saveState; 
});